module.exports = __webpack_public_path__ + "img/N134-1-EN.d36190d8.png";